import { Link } from "@icg360/design-system";
import React, { useEffect, useRef, useState } from "react";

import type { StatusPage } from "../../../../types";

export const StatusIo = () => {
  const defaults = {
    cru: {
      pagekey: "sagesureagentportal",
      url: "https://sagesureagentportal.statuspage.io"
    }
  };
  const config = {
    configStatusio: CONFIG.envConfig.statusio,
    org: CONFIG.appConfig.application.organizationId
  };
  const statusio = config.configStatusio || defaults[config.org];

  const spRef = useRef<StatusPage>();
  const [indicator, setIndicator] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (window.StatusPage) {
      spRef.current = new window.StatusPage.page({ page: statusio.pagekey });
      if (spRef.current) {
        spRef.current.summary({
          success: data => {
            setDescription(data.status.description);
            setIndicator(data.status.indicator);
          },
          error: () =>
            console.error("There was a problem getting the statuspage.io page")
        });
      }
    }
  }, []);

  return (
    <span id="js-statusio" className="group">
      <Link href={statusio.url} target="_blank" data-track="Footer: Status">
        <span className={`color-dot ${indicator}`} />
        <span className="color-description">{description}</span>
      </Link>
    </span>
  );
};
